<template>
  <div v-loading="loading" class="businessApplicationDetail">
    <div class="businessApplicationDetail-nr">
      <div class="businessApplicationDetails-first">
        <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">商务申请信息</div>
        <div :v-model="businessApplicationVO" class="businessApplicationDetail-message">
          <table cellspacing="0" cellpadding="0" class="businessApplicationTable" style="width: 100%">
            <tr>
              <td class="tableLabel">商务编号</td>
              <td>{{businessApplicationVO.businessApplicationNO}}</td>
              <td class="tableLabel">客户名称</td>
              <td>{{businessApplicationVO.customerName}}</td>
              <td class="tableLabel">付款方式</td>
              <td>{{businessApplicationVO.paymentTypeName}}</td>
            </tr>
            <tr>
              <td class="tableLabel">联系人</td>
              <td>{{businessApplicationVO.contact}}</td>
              <td class="tableLabel">联系方式</td>
              <td>{{businessApplicationVO.mobile}}</td>
              <td class="tableLabel">联系人职位</td>
              <td>{{businessApplicationVO.contactPositionName}}</td>
            </tr>
            <tr>
              <td class="tableLabel">有效期限</td>
              <td>
                <div v-if="businessApplicationVO.timeLimit === 20">
                  {{businessApplicationVO.beginDate}}
                  至
                  {{businessApplicationVO.endDate}}
                </div>
                <div v-else-if="businessApplicationVO.timeLimit === 30">永久有效</div>
                <div v-else>一次有效</div>
              </td>
              <td class="tableLabel">本次销售量</td>
              <td>{{businessApplicationVO.salesQuantity}}</td>
              <td class="tableLabel">年销售总量</td>
              <td>{{businessApplicationVO.yearSalesQuantity}}</td>
            </tr>
            <tr>
              <td class="tableLabel">状态</td>
              <td style="width: 350px">
                {{businessApplicationVO.statusName}}
              </td>
              <td class="tableLabel">提交时间:</td>
              <td>{{businessApplicationVO.submitTime}}</td>
              <td class="tableLabel">制单人</td>
              <td>{{businessApplicationVO.creatorName}}</td>
            </tr>
            <tr>
              <td class="tableLabel">制单时间</td>
              <td>{{businessApplicationVO.createdDate}}</td>
              <td class="tableLabel">免包装和运输费用</td>
              <td>{{businessApplicationVO.containsFee ? "是" : "否"}}</td>
              <td class="tableLabel">包装运输费用</td>
              <td>{{businessApplicationVO.packDeliveryFee}}</td>
            </tr>
            <tr>
              <td class="tableLabel">申请理由</td>
              <td colspan="5">{{businessApplicationVO.reason}}</td>
            </tr>
            <tr>
              <td class="tableLabel">备注</td>
              <td colspan="5">{{businessApplicationVO.note}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div style="margin-top: 20px">
        <div>
          <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">商务申请物料</div>
          <el-table ref="payData" :data="businessApplicationVO.priceVOS" border>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div style="padding-left: 47px">
                  <el-table :data="scope.row.competitorList" border>
                    <el-table-column type="index" align="center" label="#" width="55"/>
                    <el-table-column prop="brand" label="品牌" width="200"/>
                    <el-table-column prop="materialName" show-overflow-tooltip label="物料名称"/>
                    <el-table-column prop="price" label="价格" align="center" width="100"/>
                    <el-table-column prop="annualSalesQuantity" label="年销售量" align="center" width="100"/>
                  </el-table>
                </div>
              </template>
            </el-table-column>
            <el-table-column type="index" align="center" label="#" width="55"/>
            <!-- <el-table-column align="center" prop="businessTypeName" width="100" label="业务类别"/> -->
            <el-table-column 
                align="left" 
                prop="materialNo" 
                width="280" 
                show-overflow-tooltip 
                label="物料编号"/>
            <el-table-column align="left" prop="materialName" label="物料名称" show-overflow-tooltip/>
            <el-table-column 
                align="left" 
                prop="specification" 
                label="规格型号" 
                width="200" 
                show-overflow-tooltip/>
            <el-table-column prop="materialTypeName" label="物料类型" width="120" show-overflow-tooltip/>
            <el-table-column label="执行价" width="180">
              <template slot-scope="scope">
                <div>成本价：{{scope.row.costPrice === null ? "****" : scope.row.costPrice}}</div>
                <div>标准价：{{scope.row.standardPrice === null ? "****" : scope.row.standardPrice}}</div>
                <div>一阶：{{scope.row.level1Price === null ? "****" : scope.row.level1Price}}</div>
                <div>二阶：{{scope.row.level2Price === null ? "****" : scope.row.level2Price}}</div>
                <div>三阶：{{scope.row.level3Price === null ? "****" : scope.row.level3Price}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="price" label="申请价格" width="80"/>
            <el-table-column label="审批价格" width="120">
              <template slot-scope="scope">
                <div>业务经理：{{scope.row.approve1Price}}</div>
                <div>总经理：{{scope.row.approve3Price}}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div>
        <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
          商务申请附件
        </div>
        <el-table ref="payData1" border :data="businessApplicationVO.attachments">
          <el-table-column type="index" align="center" label="#"/>
          <el-table-column prop="fileName" align="left" label="附件描述" show-overflow-tooltip/>
          <el-table-column label="操作" align="center" width="120" class-name="vm-table_operate">
            <template slot-scope="scope">
              <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
  </div>
</template>

<script>
  import HandleDetail from "../../workFlow/HandleDetail";

  export default {
    name: "BusinessApplicationPreview",
    components: { HandleDetail },
    data() {
      return {
        loading: false,
        billId: "0",
        billType: "0",
        businessApplicationVO: {},
      };
    },
    watch: {
      $route: {
        immediate: true,
        handler(val) {
          if (val.query.businessApplicationID) {
            this.getData(val.query.businessApplicationID);
          }
        },
      },
    },
    created() {
      this.billId = this.$route.query.businessApplicationID + "";
      this.billType = this.$route.query.billType + "";
    },
    methods: {
      //获取数据
      getData(id) {
        this.loading = true;
        this.$http
          .get("basic", `sd/ba/${id}/0`)
          .then((resp) => {
            if (resp.success) {
              this.businessApplicationVO = resp.data;
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },

      // 下载
      downLoad(row) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(row.filePath)}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.businessApplicationDetail {
  table.businessApplicationTable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border: 1px solid #dddddd;
    border-bottom: none;
  }

  table.businessApplicationTable td {
    border: 1px solid #ddd;
    padding: 8px;
    border-top: none;
    border-right: none;
  }

  .tableLabel {
    width: 120px;
    text-align: right;
    background-color: #d1e6f5;
  }
}
</style>
